import { render, staticRenderFns } from "./BadgeDialog.vue?vue&type=template&id=279455a8&scoped=true"
import script from "./BadgeDialog.vue?vue&type=script&lang=js"
export * from "./BadgeDialog.vue?vue&type=script&lang=js"
import style0 from "./BadgeDialog.vue?vue&type=style&index=0&id=279455a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279455a8",
  null
  
)

export default component.exports